<template>
  <div>
    <Login v-if="!isOk" :type="1" :onSuccess="handleSuccess"></Login>
    <div v-else>
      <ProductList :plan-id="planId"></ProductList>
    </div>
  </div>
</template>
<script>
import Login from "../components/Login";
import {Grid, GridItem, Button, Empty} from 'vant'
import store from "../store";
import ProductList from "../components/ProductList";
export default {
  components: {
    ProductList,
    Login,
    Grid,
    GridItem,
    Button,
    Empty
  },
  data () {
    return {
      id: '',
      isOk: false,
      sharedStore: store.state,
      planId: ''
    }
  },
  methods: {
    handleSuccess () {
      const { planId } = this.sharedStore
      this.isOk = true
      this.planId = planId
    }
  },
  mounted() {
    if (this.sharedStore.token) {
      this.isOk = true
      this.handleSuccess()
    }
  }
}
</script>
